<app-view-item *ngIf="disabled" [text]="displayText" [borderless]="borderless"></app-view-item>

<nz-select *ngIf="!disabled" [nzDisabled]="allowEdit === false" nz-input [(ngModel)]="value" (ngModelChange)="onModelChange($event)"
  [nzDropdownMatchSelectWidth]="false" nzAllowClear="false">
  <nz-option [nzValue]="item.value" [nzLabel]="item.value" *ngFor="let item of options"></nz-option>
</nz-select>
